export default __webpack_public_path__ + "img/3df29103a99994f9803e3ca17a125587.png";